import { render } from "./PersonalInfo.vue?vue&type=template&id=e7c50e6c&scoped=true&bindings={\"handleLogout\":\"setup\",\"handleAddressClick\":\"setup\",\"userInfo\":\"setup\"}"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=e7c50e6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e7c50e6c"

export default script